import { apiPost } from './apiConfig';

/**
 * Submit user feedback and suggestions
 */
export const submitFeedback = async (suggestion: string): Promise<any> => {
  return await apiPost('/feedback/', { suggestion });
};

